import React, { useEffect } from "react";
import { useForm } from "react-hook-form";

const FilterComponent3 = (props) => {
  const {
    handleDuration,
    allCPs,
    isServiceRevenue,
    handleDownload,
    userSessions,
    networkData,
    setShowTable,
    setSelectedType,
  } = props;

  const {
    register: register1,
    handleSubmit: handleSubmit1,
    formState: {
      errors: errors1,
      isSubmitting: isSubmitting1,
      isValid: isValid1,
    },
  } = useForm({
    mode: "onChange",
    defaultValues: {
      type: "charging",
      cp_id: "",
      from: new Date(Date.now() - 86400000).toISOString().substr(0, 10),
      to: new Date(Date.now() - 86400000).toISOString().substr(0, 10),
    },
  });

  useEffect(() => {
    handleSubmit1(handleDuration)();
  }, []);

  if (isServiceRevenue) {
    return (
      <div className="row mb-10 mt-40 " style={{ marginLeft: "-30px" }}>
        <form onSubmit={handleSubmit1(handleDuration)} className="">
          <div className="col-2 col-sm-2 pr-0 ">
            <select
              className="filter_text"
              {...register1("type", {
                required: "Please select a type",
              })}
              style={{ textTransform: "capitalize" }}
              onChange={(e) => {
                setSelectedType(e.target.value);
                setShowTable(false);
              }}
            >
              <option value="">-Select Type-</option>
              {networkData &&
                networkData.length > 0 &&
                networkData.map((network) => {
                  return (
                    <option key={network.id} value={network.value}>
                      {network.name}
                    </option>
                  );
                })}
            </select>
            {errors1.type && (
              <small className="text-danger">{errors1.type.message}</small>
            )}
          </div>

          <div className="col-sm-10 pl-5 pr-15 mt-xs-5 pl-xs-20 ">
            <div className="row">
              <div className="col-sm-3 pr-0">
                <select
                  className="filter_text"
                  {...register1("cp_id")}
                  style={{ textTransform: "capitalize" }}
                >
                  <option value="">-Select CP-</option>
                  {allCPs &&
                    allCPs.length > 0 &&
                    allCPs.map((cp) => {
                      return (
                        <option key={cp.id} value={cp.id}>
                          {cp.name}
                        </option>
                      );
                    })}
                </select>
                {errors1.cp_id && (
                  <small className="text-danger">{errors1.cp_id.message}</small>
                )}
              </div>
              <div className="col-sm-3 col-3 pl-5 pr-0">
                <input
                  type="date"
                  className="filter_text"
                  placeholder="From Date"
                  {...register1("from", { required: "From date is required" })}
                  max={new Date().toISOString().substr(0, 10)}
                />
                {errors1.from && (
                  <small className="text-danger">{errors1.from.message}</small>
                )}
              </div>
              <div className="col-sm-3 col-3 pl-5 pr-0">
                <input
                  type="date"
                  className="filter_text"
                  placeholder="To Date"
                  {...register1("to", { required: "To date is required" })}
                  max={new Date().toISOString().substr(0, 10)}
                />
                {errors1.to && (
                  <small className="text-danger">{errors1.to.message}</small>
                )}
              </div>
              <div className="col-sm-1 col-1 p-0">
                <button
                  className="btn_1 btn-primary w-100"
                  type="submit"
                  disabled={isSubmitting1}
                  style={{
                    opacity: isSubmitting1 ? "0.5" : 1,
                    minHeight: "38px",
                  }}
                >
                  {isSubmitting1 ? (
                    <>
                      <i className="fa fa-spinner fa-spin mr-2"></i>
                      Loading...
                    </>
                  ) : (
                    <>
                      <i className="fa fa-search mr-2"></i>
                      Filter
                    </>
                  )}
                </button>
              </div>
              <div className="col-sm-1 col-1 p-0 ms-2">
                <button
                  className="btn_1 btn-primary w-100"
                  type="button"
                  onClick={handleDownload}

                  //   style={{
                  //     opacity: isSubmitting1 ? "0.5" : 1,
                  //     minHeight: "38px",
                  //   }}
                >
                  <>
                    {/* <i className="fa fa-file-excel mr-2"></i> */}
                    {/* <i class="fa fa-download me-2"></i> */}
                    Download
                  </>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
};

export default FilterComponent3;
